import { addDays, format } from 'date-fns'
import QueryString from 'qs'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useLocation, useNavigate } from 'react-router-dom'
import { styled } from 'styled-components'
import { CoinType } from '../../@types/aboutfishing'
import { postOpenid } from '../../api/auth'
import { getAccumulations, getAccumulationsExpire } from '../../api/profile'
import CoinExpireCenterModal from '../../components/myshopping/CoinExpireCenterModal'
import CoinExpireModal from '../../components/myshopping/CoinExpireModal'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import { plusComma } from '../../js/script'
import { imgURL } from '../Home'

type TabType = { label: string; type: string }

export default function SaveDetail() {
  const tab: TabType[] = [
    { label: '전체', type: 'total' },
    { label: '적립', type: 'plus' },
    { label: '취소', type: 'cancel' },
    { label: '차감', type: 'minus' },
    { label: '소멸', type: 'extinction' },
  ]
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [type, setType] = useState<string>('total')
  const [item, setItem] = useState<any>([])
  const [coin, setCoin] = useState<CoinType>()
  const [locationText, setLocationText] = useState<any>('')
  const [coinExpireModal, setCoinExpireModal] = useState<boolean>(false)
  const [waitingAccumulation, setWaitingAccumulation] = useState<number>(0)
  const [currentDateTime, setCurrentDateTime] = useState<string>('')
  const [beforeDateTime, setBeforeDateTime] = useState<string>('')
  const [expirePrev, setExpirePrev] = useState<any>([])
  // const [expireItem, setExpireItem] = useState<any>([])
  const { hasAccessToken } = useCommonContext()

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const query = QueryString.parse(location.search, {
      ignoreQueryPrefix: true,
    })
    setLocationText(query)
    if (query.app === 'true') {
      window.sessionStorage.setItem('app', JSON.stringify(true))
    }
  }, [location])

  useEffect(() => {
    if (locationText) {
      if (locationText?.token) {
        postOpenid(locationText.token)
          .then((res) => {
            window.localStorage.setItem(`accessToken`, JSON.stringify(res.data.accessToken))
            window.localStorage.setItem('aboutAccessToken', JSON.stringify(locationText.token))
            navigate('/accumulation')
            window.location.reload()
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }, [locationText])

  useEffect(() => {
    const today = format(addDays(new Date(), 30), 'yyyy-MM-dd HH:mm:ss') // 30일 후 날짜 포맷
    const before30 = format(addDays(new Date(), -30), 'yyyy-MM-dd HH:mm:ss') // 30일 전 날짜
    setCurrentDateTime(today) // 30일 후의 현재 날짜를 상태로 설정
    setBeforeDateTime(before30) // 30일 전 날짜를 상태로 설정
  }, [])

  useEffect(() => {
    if (hasAccessToken) {
      setIsLoading(true)

      const actions: { [key: string]: () => Promise<void> } = {
        total: async () => {
          const res = await getAccumulations('')
          setItem(res.data.items)
          setCoin(res.data.totalAmt)
          // setExpireItem(res.data.items)
        },
        plus: async () => {
          const res = await getAccumulations('ADD')
          setItem(res.data.items)
        },
        cancel: async () => {
          setItem([])
        },
        minus: async () => {
          const res = await getAccumulations('SUB')
          setItem(res.data.items)
        },
        extinction: async () => {
          const res = await getAccumulations('SUB')
          const array = res.data.items.filter((el: any) => el.accumulationReserveReason === 'SUB_EXPIRED')
          setItem(array)
        },
      }

      if (actions[type]) {
        actions[type]().finally(() => setIsLoading(false))
      } else {
        setIsLoading(false)
      }
    }
  }, [type])

  useEffect(() => {
    if (!currentDateTime || !beforeDateTime) return

    getAccumulationsExpire(beforeDateTime, currentDateTime).then((res) => {
      setExpirePrev(res.data.expirations)
      setWaitingAccumulation(res.data.expiresAmount)
    })
  }, [currentDateTime, beforeDateTime])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>적립금 내역</PageTitle>

            <CoinWrap>
              <div className='coin_cont'>
                <div className='inner_box'>
                  {coin ? <p>{plusComma(coin)}</p> : <LoadingCoin>적립금을 조회중입니다.</LoadingCoin>}
                  <div>
                    <button
                      type='button'
                      onClick={() => {
                        setCoinExpireModal(true)
                      }}
                    >
                      소멸예정 : {plusComma(waitingAccumulation)}원
                      <img src='../../images/icon_s_arrow.png' />
                    </button>
                  </div>
                </div>
              </div>
            </CoinWrap>
            {coinExpireModal &&
              (isMobile ? (
                <CoinExpireModal
                  setCoinExpireModal={setCoinExpireModal}
                  items={expirePrev}
                  expiresAmount={waitingAccumulation}
                />
              ) : (
                <CoinExpireCenterModal
                  setCoinExpireModal={setCoinExpireModal}
                  items={expirePrev}
                  expiresAmount={waitingAccumulation}
                />
              ))}

            <TabWrap>
              {tab.map((el: any) => {
                return (
                  <Tab
                    key={el.label}
                    className={type === el.type ? 'on' : ''}
                    onClick={() => {
                      setType(el.type)
                    }}
                  >
                    {el.label}
                  </Tab>
                )
              })}
            </TabWrap>

            <CoinList>
              {isLoading ? (
                <Loading>조회중입니다..</Loading>
              ) : item.length !== 0 ? (
                <div className='list_wrap'>
                  <div className='tit'>
                    <dl>
                      <dt>내역</dt>
                      <dd>적립금</dd>
                    </dl>
                  </div>
                  <div className='list'>
                    {item.map((el: any, index: number) => (
                      <CoinDetailList key={index} el={el}></CoinDetailList>
                    ))}
                  </div>
                </div>
              ) : (
                <div className='no_data'>
                  <img src={`${imgURL}/empty_logo.png`} alt='' />
                  {type === 'total' && '피싱코인 전체 내역이 없습니다.'}
                  {type === 'plus' && '피싱코인 적립 내역이 없습니다.'}
                  {type === 'cancel' && '피싱코인 취소 내역이 없습니다.'}
                  {type === 'minus' && '피싱코인 차감 내역이 없습니다.'}
                  {type === 'extinction' && '피싱코인 소멸 내역이 없습니다.'}
                </div>
              )}
            </CoinList>
          </div>
        </div>
      </div>
    </>
  )
}

function CoinDetailList({ el }: any) {
  const isPayment = el.accumulationStatusGroupType === 'PAYMENT'
  const formattedDate = el.registerYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')

  return (
    <dl className={isPayment ? 'save' : ''}>
      <dt>
        <span>{formattedDate}</span>
        <p>{el.reasonDetail}</p>
      </dt>
      <dd>
        <p>{`${isPayment ? '+' : '-'}${plusComma(el.accumulationAmt)}`}</p>
        <span>{isPayment ? '적립' : '차감'}</span>
      </dd>
    </dl>
  )
}

export const CoinList = styled.div`
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  & .tit {
    & dl {
      display: flex;
      justify-content: space-between;
      align-items: center;
      & dt {
        font-size: 15px;
        line-height: 18px;
        color: var(--colBlack);
        font-weight: 600;
      }
      & dd {
        font-size: 15px;
        line-height: 18px;
        color: var(--colBlack);
        font-weight: 600;
      }
    }
  }
  & .list_wrap {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 24px 20px 48px 20px;
    & .tit {
      & dl {
        display: flex;
        justify-content: space-between;
        align-items: center;
        & dt {
          font-size: 15px;
          line-height: 18px;
          color: var(--colBlack);
          font-weight: 600;
        }
        & dd {
          font-size: 15px;
          line-height: 18px;
          color: var(--colBlack);
          font-weight: 600;
        }
      }
    }
    @media screen and (min-width: 768px) {
      padding: 24px 0 48px 0;
    }
  }

  & .list {
    & dl {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid var(--colGray2);
      &:last-child {
        border: 0;
      }
      & dt {
        & span {
          display: block;
          font-size: 13px;
          font-weight: 400;
          line-height: 16px;
          color: var(--colGray6);
          margin-bottom: 5px;
        }
        & p {
          font-size: 14px;
          line-height: 18px;
          color: var(--colBlack);
        }
      }

      & dd {
        text-align: right;
        & p {
          font-size: 14px;
          line-height: 18px;
          color: #ff1717;
          font-weight: 600;
          margin-bottom: 3px;
        }
        & span {
          display: inline-block;
          font-size: 11px;
          font-weight: 500;
          line-height: 12px;
          padding: 3px 8px;
          background: var(--colGray2);
          border-radius: 9px;
        }
      }
      &.save {
        & dd {
          & p {
            color: var(--colPointBlue);
          }
        }
      }
    }
  }
  & .no_data {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: var(--colGray5);
    padding: 80px 0 100px 0;
  }
  & .no_data > img {
    width: 85px;
    height: 85px;
    margin: 0 auto;
  }
  @media screen and (min-width: 768px) {
    & .no_data {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      font-weight: 500;
      line-height: 32px;
      color: var(--colGray5);
      padding: 120px 0 160px 0;
    }
    & .no_data > img {
      width: 108px;
      height: 108px;
      margin: 0 auto;
    }
  }
`
export const CoinWrap = styled.div`
  padding: 0 20px;
  margin: 8px 0 0 0;
  & .coin_cont {
    position: relative;
    background: var(--colGray1);
    border-radius: 12px;
    padding: 0 12px;
    text-align: center;

    & .inner_box {
      padding: 32px 0;
      margin-bottom: 18px;
      & p {
        display: inline-block;
        font-size: 26px;
        line-height: 32px;
        color: var(--colBlack);
        font-weight: 500;
        position: relative;
        padding-right: 20px;
        &:after {
          content: '';
          width: 16px;
          height: 16px;
          background: url('../../images/icon_point.png') no-repeat;
          background-size: contain;
          position: absolute;
          top: 8px;
          right: 0;
        }
      }
      & div {
        margin-top: 4px;
        & button {
          display: flex;
          align-items: center;
          gap: 2px;
          font-size: 13px;
          font-weight: 500;
          line-height: 16px;
          color: var(--colGray6);
          border: 0;
          padding: 0;
          margin: 0 auto;
          background: transparent;
          cursor: pointer;
          & img {
            width: 10px;
            height: 10px;
          }
        }
      }
    }
  }
  @media screen and (min-width: 768px) {
    padding: 0;
    margin: 32px 0 24px 0;
    & .coin_cont {
      padding: 10px;
      & .inner_box {
        padding: 28px 0;
        margin: 0;
        & div {
          margin-top: 5px;
        }
      }
    }
  }
`

// 탭 Wrap
export const TabWrap = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  @media screen and (min-width: 768px) {
    gap: 20px;
    height: 50px;
    margin: 0;
    border-bottom: 1px solid var(--colGray3);
  }
`
// 상품 상세정보, 리뷰 탭
export const Tab = styled.div`
  flex: 1;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--colGray5);
  background: var(--colWhite);
  border-bottom: 1px var(--colGray3) solid;
  cursor: pointer;
  & span {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    color: var(--colPointBlue);
    margin-left: 3px;
  }
  &.on {
    color: var(--colBlack);
    border-bottom: 1px var(--colBlack) solid;
  }
  @media screen and (min-width: 768px) {
    flex: none;
    border-bottom: none;
    overflow: hidden;
    color: var(--colGray5, #aaa);
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    padding: 0 2px;
    &.on {
      position: relative;
      top: 1px;
      color: var(--colBlack);
      font-weight: 700;
      border-bottom: 2px var(--colBlack) solid;
    }
  }
`

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  font-size: 16px;
`
export const LoadingCoin = styled.span`
  font-size: 16px;
  color: #000;
  line-height: 32px;
  display: block;
`
